import { useState, useMemo } from 'react';
import getOmsUrl from '@utils/getOmsUrl';
import { simpleValidateEmail } from '@utils/validateEmail';

export const useEmailCapture = (id: string) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successful, setSuccessful] = useState(false);

  const isValidEmail = useMemo(() => simpleValidateEmail(email), [email]);

  const setErrorMessage = () => {
    setError('Failed to join waitlist. Please try again later.');
    setTimeout(() => {
      setError('');
      setLoading(false);
    }, 5000);
  };

  const handleAddToNewsletter = () => {
    setLoading(true);

    if (!id) {
      setErrorMessage();
      return;
    }

    const oms = getOmsUrl();
    const url = `${oms}/klaviyo/${id}/add`;
    const body = JSON.stringify({
      profiles: [
        {
          email,
          consent: 'web'
        }
      ]
    });
    const options = {
      method: 'POST',
      headers: {
        'api-key': process.env.KLAVIYO_KEY || '',
        'Content-Type': 'application/json'
      },
      body
    };

    fetch(url, options)
      .then(() => {
        setLoading(false);
        setSuccessful(true);
        setTimeout(() => {
          setEmail('');
          setSuccessful(false);
        }, 5000);
      })
      .catch((err) => {
        console.error(err);
        setErrorMessage();
      });
  };

  return {
    email,
    setEmail,
    error,
    setError,
    isChecked,
    setIsChecked,
    loading,
    successful,
    isValidEmail,
    handleAddToNewsletter
  };
};
